import { useOrderExpiryTypeCommon } from '@eih-netbroker/common';
import { useOptions } from '../../../../shared/services/useOptions';
import { useUserSettings } from '../../../../shared/services/user-settings/useUserSettings';

export const useOrderExpiryType = () => {
  const { getExpiryTypeOptions } = useOptions();
  const { userInterfaceSettings } = useUserSettings();
  const { getDefaultExpiryType, getDefaultExpiryDate } = useOrderExpiryTypeCommon({
    getExpiryTypeOptions,
    userInterfaceSettings,
  });

  return {
    getDefaultExpiryType,
    getDefaultExpiryDate,
  };
};
